import * as React from "react";

import "./NewCallModal.css";

import { connect } from "react-redux";

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { IProfile, IPushRequest } from "../api/APIClient";
import Loader from "../components/Loader";
import { createPush } from "../thunks";
import { RootState } from "../types";

interface IProps {
  users: IProfile[];
  isOpen: boolean;
  isLoading: boolean;
  toggleOpen: () => void;
  onSubmit: (cast: IPushRequest) => void;
}

interface IState {
  text: string;
}

export class NewPushModal extends React.Component<IProps, IState> {
  public state = {
    text: "",
  };

  public render() {
    const { text } = this.state;
    const { isOpen, toggleOpen, isLoading } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={toggleOpen}>
        <ModalHeader toggle={toggleOpen}>New Push</ModalHeader>
        <ModalBody>
          <form onSubmit={this.onSubmit}>
            <textarea
              className="form-control"
              value={text}
              onChange={this.onChangeText}
            />
          </form>
        </ModalBody>
        <ModalFooter>
          <Loader visible={isLoading} />
          <Button onClick={this.onSubmit} color="primary">
            {"Send Push"}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  private onSubmit = () => {
    const { text } = this.state;
    const { users, onSubmit } = this.props;

    const userIDs = users.map(u => u.id);

    onSubmit({
      text,
      users: userIDs,
    });
  };

  private onChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.currentTarget;

    this.setState({
      text: value,
    });
  };
}

export const NewPushContainer = connect(
  ({ push }: RootState) => ({
    isLoading: push.isLoading,
  }),
  dispatch => ({
    onSubmit: (push: IPushRequest) => dispatch<any>(createPush(push)),
  })
)(NewPushModal);

export default NewPushContainer;



// WEBPACK FOOTER //
// ./src/pages/NewPushModal.tsx